module.exports = __webpack_public_path__ + "static/media/introduce_icon.1678f01f.svg";